var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('layout',{attrs:{"back":true}}),_c('v-row',[(_vm.type == 'candidate')?_c('v-col',[_c('candidate-configuration')],1):_c('v-col',[_c('pharmacy-configuration')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }